import Box from "@/common/components/Box";
import DropdownMenu from "@/common/components/DropdownMenu";
import ResumeItem from "@/common/components/ResumeItem";
import { FiscalDocumentData } from "@/features/billingBills/types/fiscalDocument.type";

interface MainFiscalDocumentProps {
  fiscalDocument: FiscalDocumentData;
}

const MainFiscalDocument = ({ fiscalDocument }: MainFiscalDocumentProps) => {
  return (
    <Box className="p-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <ResumeItem
          label="Número da nota"
          value={fiscalDocument.number || '--'}
        />
      </div>

      <div className="flex items-center gap-3">
        <DropdownMenu
          triggerLabel="Baixar nota"
          options={[
            {
              label: 'PDF',
              onClick: () => fiscalDocument?.pdf?.url && window.open(fiscalDocument?.pdf?.url, '_blank'),
              disabled: !fiscalDocument?.pdf?.url,
            },
            {
              label: 'XML',
              onClick: () => fiscalDocument?.xml?.url && window.open(fiscalDocument?.xml?.url, '_blank'),
              disabled: !fiscalDocument?.xml?.url,
            },
          ]}
        />
      </div>
    </Box>
  );
}

export default MainFiscalDocument;
